import Base from "utils/base";
import { CreateTagInput , UpdateTagInput } from "framework/rest/types";

class Tag extends Base<CreateTagInput, UpdateTagInput> {}

const tagInstance = new Tag();

export default tagInstance;